<script>
  import { adminAuth } from "../../stores/adminAuth.js"
  import { push } from "svelte-spa-router"

  let username = ""
  let password = ""
  let newPassword = ""
  let newPasswordConfirm = ""
  let showNewPasswordForm = false
  let pendingUser = null

  $: authState = $adminAuth

  $: if (authState.isAuthenticated && !authState.isLoading) {
    push("/admin/dashboard")
  }

  async function handleLogin() {
    if (!username || !password) return

    adminAuth.clearError()

    const result = await adminAuth.login(username, password)

    if (result.requireNewPassword) {
      showNewPasswordForm = true
      pendingUser = result.user
    }
  }

  async function handleSetNewPassword() {
    adminAuth.clearError()

    if (!newPassword || newPassword !== newPasswordConfirm) {
      adminAuth.setError("PASSWORD_ERROR", "パスワードが一致しません")
      return
    }

    // パスワード長チェック
    if (newPassword.length < 8) {
      adminAuth.setError(
        "PASSWORD_ERROR",
        "パスワードは8文字以上である必要があります"
      )
      return
    }
    await adminAuth.setNewPassword(newPassword)
  }

  function handleKeydown(event) {
    if (event.key === "Enter") {
      if (showNewPasswordForm) {
        handleSetNewPassword()
      } else {
        handleLogin()
      }
    }
  }
</script>

<div class="wrapper">
  <div class="simple-card">
    <h2 class="title">管理者ログイン</h2>
    {#if authState.error}
      <div class="error-message">
        <span>{authState.error.message}</span>
      </div>
    {/if}
    {#if !showNewPasswordForm}
      <form on:submit|preventDefault={handleLogin}>
        <div class="form-group">
          <label for="username">ユーザー名</label><br />
          <input
            id="username"
            type="text"
            bind:value={username}
            placeholder="ユーザー名"
            required
            disabled={authState.isLoading}
            on:keydown={handleKeydown}
            class="input-box"
            autocomplete="username"
          />
        </div>
        <div class="form-group">
          <label for="password">パスワード</label><br />
          <input
            id="password"
            type="password"
            bind:value={password}
            placeholder="パスワード"
            required
            disabled={authState.isLoading}
            on:keydown={handleKeydown}
            class="input-box"
            autocomplete="current-password"
          />
        </div>
        <button
          type="submit"
          class="indigo full-width mt-1"
          disabled={authState.isLoading || !username || !password}
        >
          {authState.isLoading ? "ログイン中..." : "ログイン"}
        </button>
      </form>
    {:else}
      <form on:submit|preventDefault={handleSetNewPassword}>
        <div class="form-group">
          <label for="new-password">新しいパスワード</label><br />
          <input
            id="new-password"
            type="password"
            bind:value={newPassword}
            placeholder="新しいパスワード"
            required
            disabled={authState.isLoading}
            on:keydown={handleKeydown}
            class="input-box"
          />
          <small class="desc"
            >8文字以上、大文字・小文字・数字を含む必要があります</small
          >
        </div>
        <div class="form-group">
          <label for="new-password-confirm">パスワード確認</label><br />
          <input
            id="new-password-confirm"
            type="password"
            bind:value={newPasswordConfirm}
            placeholder="パスワード再入力"
            required
            disabled={authState.isLoading}
            on:keydown={handleKeydown}
            class="input-box"
          />
        </div>
        <button
          type="submit"
          class="indigo full-width mt-1"
          disabled={authState.isLoading || !newPassword || !newPasswordConfirm}
        >
          {authState.isLoading ? "設定中..." : "パスワードを設定"}
        </button>
      </form>
    {/if}
  </div>
</div>

<style lang="scss">
  .wrapper {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .simple-card {
    background: white;
    padding: 2em 1.5em;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
    width: 100%;
    max-width: 40vw;
  }
  .title {
    text-align: center;
  }
  .form-group {
    margin-bottom: 1em;
  }
  .input-box {
    width: 100%;
    padding: 0.5em;
    margin-top: 0.5em;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 1em;
    box-sizing: border-box;
  }
  .indigo {
    background: #3f51b5;
    color: white;
    border: none;
    border-radius: 6px;
    padding: 0.7em 0;
    font-size: 1em;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.2s;
  }
  .indigo:disabled {
    background: #ccc;
    color: #fff;
    cursor: not-allowed;
  }
  .full-width {
    width: 100%;
  }
  .mt-1 {
    margin-top: 1em;
  }
  .info-message {
    margin-bottom: 1em;
    color: #1976d2;
    background: #e3f2fd;
    padding: 0.5em;
    border-radius: 4px;
  }
  .desc {
    color: #666;
    font-size: 0.95em;
    display: block;
    margin-top: 0.3em;
  }
  .error-message {
    background: #ffebee;
    color: #c62828;
    padding: 0.5em;
    border-radius: 4px;
    margin-top: 1em;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
  .clear-error {
    background: none;
    border: none;
    color: #c62828;
    font-size: 1.2em;
    cursor: pointer;
    margin-top: 0.5em;
  }
  .clear-error {
    background: none;
    border: none;
    color: #c62828;
    font-size: 1.2em;
    cursor: pointer;
  }
</style>
